export enum SurveyEvent {
  Start = 'Survey - Start',
  Complete = 'Survey - Complete',
  SaveResponse = 'Survey - Save Response',
  EarlyExitAlert = 'Survey - Early Exit Alert',
  EarlyExitConfirmed = 'Survey - Early Exit Confirmed',
  EarlyExitCanceled = 'Survey - Early Exit Canceled',
  SurveyFallbackUsed = 'Survey - Fallback Used'
}

export enum NavigationEvent {
  FallbackUsed = 'Navigation - Fallback Used'
}

export enum InsuranceSurveyEvents {
  EligibleScreen = 'Insurance Survey - Web - Eligible Screen',
  IneligibleScreen = 'Insurance Survey - Web - Ineligible Screen'
}

export enum Scheduling {
  InitialAppointmentTypeViewed = 'Scheduling - Web - Initial Appointment Type Viewed',
  AppointmentBooked = 'Scheduling - Web - Appointment Booked',
  AppointmentRescheduled = 'Scheduling - Web - Appointment Rescheduled',
  AppointmentCanceled = 'Scheduling - Web - Appointment Canceled',
  AppointmentReserved = 'Scheduling - Web - Appointment Reserved',
  NoAvailableDates = 'Scheduling - Web - No Available Dates',
  SlotIsAlreadyTaken = 'Scheduling - Web - Slot Is Already Taken',
  CoachNotLicensed = 'Scheduling - Web - Coach Not Licensed'
}

export enum InsuranceBenefitsCheck {
  Started = 'Insurance Benefits Check - Started',
  Completed = 'Insurance Benefits Check - Completed',
  Failed = 'Insurance Benefits Check - Failed'
}

export enum VideoCalls {
  HealthGoal = 'User - Video Call Goal',
  SecondaryHealthGoal = 'User - Video Call Secondary Health Goal',
  WeightLossQuoteViewed = 'User - Weight Loss Quote Viewed',
  InsuranceResponse = 'Standalone - Insurance Response',
  InsuranceSupportedViewed = 'Standalone - Insurance Supported Viewed',
  InsuranceNotAcceptedViewed = 'Standalone - Insurance Not Accepted Viewed',
  SubmitEmail = 'User - Submit Email Address',
  SubmitState = 'User - Submit State',
  SubmitAgenda = 'Standalone - Submit Agenda',
  HeardAboutUs = 'Standalone - Heard about us',
  EmailStepNotCompleted = 'Standalone - Email Step Not Completed',
  NutritionistBioViewed = 'User - Nutritionist Bio Viewed',
  RDWelcomeVideoOpened = 'User - RD Welcome Video Opened',
  CheckoutPaymentSuccessful = 'User - Video Call Checkout - Payment Successful',
  SteloIntegrateAccount = 'Integrate Stelo Account',
  SteloIntegrateAccountNotNow = 'Integrate Stelo Account - Not Now',
  SteloIntegrateAccountBannerClicked = 'Integrate Stelo Account - Banner Clicked',
  SteloIntegrateSuccessfully = 'Integrate Stelo Account - Successfully Integrated',
  SteloIntegrateNotSuccess = 'Integrate Stelo Account - Integration Failed',
  DexcomG7IntegrateAccount = 'Integrate Dexcom G7 Account',
  DexcomG7IntegrateAccountNotNow = 'Integrate Dexcom G7 Account - Not Now',
  DexcomG7IntegrateAccountBannerClicked = 'Integrate Dexcom G7 Account - Banner Clicked',
  DexcomG7IntegrateSuccessfully = 'Integrate Dexcom G7 Account - Successfully Integrated',
  DexcomG7IntegrateNotSuccess = 'Integrate Dexcom G7 Account - Integration Failed',
  CheckoutViewed = 'User - Video Call Checkout - Viewed'
}

export enum VideoCallsFiltering {
  DefaultSpecialtiesFilterApplied = 'Video Calls Filtering - Default Specialties Filter Applied',
  SpecialtiesFilterUpdated = 'Video Calls Filtering - Specialties Filter Updated',
  SpecialtiesFilterMenuOpened = 'Video Calls Filtering - Specialties Filter Menu Opened',
  SpecialtiesFilterMenuClosed = 'Video Calls Filtering - Specialties Filter Menu Closed',
  TimeFilterMenuOpened = 'Video Calls Filtering - Time Filter Menu Opened',
  TimeFilterMenuClosed = 'Video Calls Filtering - Time Filter Menu Closed',
  FromTimeSelected = 'Video Calls Filtering - From Time Selected',
  ToTimeSelected = 'Video Calls Filtering - To Time Selected',
  TimeFilterReset = 'Video Calls Filtering - Time Filter Reset',
  ShowingUnavailableSlots = 'Video Calls Filtering - Showing Unavailable Slots',
  UnavailableSlotConfirmed = 'Video Calls Filtering - Unavailable Slot Confirmed'
}

export enum WeightLossExperience {
  Started = 'Weight Loss Experience - Web - Started',
  DesiredWeightStartScreen = 'Weight Loss Experience - Web - Desired Weight Start Screen',
  DesiredWeightStartScreenStartFlow = 'Weight Loss Experience - Web - Desired Weight Start Screen - Start Flow',
  DesiredWeightStartScreenWithMyNutritionist = 'Weight Loss Experience - Web - Desired Weight Start Screen - With My Nutritionist',
  DesiredWeightCompletedScreenRealistic = 'Weight Loss Experience - Web - Desired Weight Completed Screen - Realistic',
  DesiredWeightCompletedScreenChallenging = 'Weight Loss Experience - Web - Desired Weight Completed Screen - Challenging',
  DesiredWeightCompletedScreenContinue = 'Weight Loss Experience - Web - Desired Weight Completed Screen - Continue',
  CreatingPlanScreen = 'Weight Loss Experience - Web - Creating Plan Screen',
  PlanDetailsScreen = 'Weight Loss Experience - Web - Plan Details Screen',
  ScheduleRecurrentCallsScreen = 'Weight Loss Experience - Web - Schedule Recurrent Calls Screen',
  ConfirmedScreen = 'Weight Loss Experience - Web - Confirmed Screen'
}

export enum OnboardingExperience {
  Started = 'Onboarding Experience - Web - Started',
  BasicInformationStartScreen = 'Onboarding Experience - Web - Basic Information Start Screen',
  BasicInformationStartScreenStartFlow = 'Onboarding Experience - Web - Basic Information Start Screen - Start Flow',
  BasicInformationStartScreenWithMyNutritionist = 'Onboarding Experience - Web - Basic Information Start Screen - With My Nutritionist',
  BasicInformationCompletedScreenRealistic = 'Onboarding Experience - Web - Basic Information Completed Screen - Realistic',
  BasicInformationCompletedScreenChallenging = 'Onboarding Experience - Web - Basic Information Completed Screen - Challenging',
  BasicInformationCompletedScreenContinue = 'Onboarding Experience - Web - Basic Information Completed Screen - Continue',
  CreatingPlanScreen = 'Onboarding Experience - Web - Creating Plan Screen',
  PlanDetailsScreen = 'Onboarding Experience - Web - Plan Details Screen',
  ScheduleRecurrentCallsScreen = 'Onboarding Experience - Web - Schedule Recurrent Calls Screen',
  ConfirmedScreen = 'Onboarding Experience - Web - Confirmed Screen'
}

export enum OwnSensorV2 {
  LoadingScreenViewed = 'OwnSensor - Loading Screen - View',
  SelectedSensor = 'OwnSensor - Sensor Selection - Select',
  LibreIndirectSyncConfirmed = 'OwnSensor - Libre Indirect Sync Confirmation - I Understand Clicked',
  IHaveNoSensor = 'OwnSensor - I Have No Sensor',
  SelectedGoal = 'OwnSensor - Goal - Select',
  Quote1Viewed = 'OwnSensor - Quote 1 - View',
  TrackedGlucoseAnswer = 'OwnSensor - Tracked Glucose Answer',
  AppOverviewViewed = 'OwnSensor - App Overview - View',
  HeightAnswer = 'OwnSensor - Height Answer',
  WeightAnswer = 'OwnSensor - Weight Answer',
  WellnessSnapshotViewed = 'OwnSensor - Wellness Snapshot - View',
  GoalWeightAnswer = 'OwnSensor - Goal Weight Answer',
  Quote2Viewed = 'OwnSensor - Quote 2 - View',
  ChronicConditionsAnswer = 'OwnSensor - Chronic Conditions Answer',
  FamilyDiabetesAnswer = 'OwnSensor - Family Diabetes Answer',
  Quote3Viewed = 'OwnSensor - Quote 3 - View',
  LateNightCravingsAnswer = 'OwnSensor - Late Night Cravings Answer',
  TiredAfterMealsAnswer = 'OwnSensor - Tired After Meals Answer',
  CurrentlyWearingCGMAnswer = 'OwnSensor - Currently Wearing CGM Answer',
  SelectedProduct = 'OwnSensor - Selected Product',
  SetPassword = 'OwnSensor - Set Password'
}

export enum UserEvents {
  ViewSignUp = 'User - View Sign Up',
  SignUp = 'User - Sign Up',
  Identify = 'User - Identify',
  SubmitAddress = 'User - Submit Address',
  CreateSubscription = 'User - Create Subscription',
  CreditCardAdded = 'User - Credit Card Added',
  ExpressCheckoutConfirm = 'User - Express Checkout Confirm'
}

export enum UserEventsSource {
  VideoCallFlow = 'Video Call Flow',
  PaidVideoCallFlow = 'Paid Video Call Flow',
  MedicalFlow = 'Medical Flow',
  Checkout = 'Checkout',
  OwnSensorFlow = 'Own Sensor Flow',
  OwnSensorCheckout = 'Own Sensor Checkout',
  PartnerFlow = 'Partner Flow',
  UhcSamlFlow = 'UHC SAML Flow',
  StressManagementFlow = 'Stress Management Flow'
}

export enum Uhc {
  OnboardingSurveyStartScreen = 'Uhc - Web - Onboarding Survey - Start Screen',
  OnboardingSurveyStartScreenWithMyCoach = 'Uhc - Web - Onboarding Survey - Start Screen - With My Coach',
  OnboardingSurveyStarted = 'Uhc - Web - Onboarding Survey - Started'
}

export enum UpgradeEvents {
  CheckoutSkipped = 'Upgrade - Checkout - Skipped',
  CheckoutUpgraded = 'Upgrade - Checkout - Upgraded',
  TimerClicked = 'Upgrade - Timer - Clicked',
  TimerSkipped = 'Upgrade - Timer - Skipped',
  TimerUpgraded = 'Upgrade - Timer - Upgraded'
}

export enum Recurrence {
  AppointmentRecurrenceEmptyAvailability = 'Appointment Recurrence - Empty Availability'
}

export enum StressManagement {
  PaidIntroScreenView = 'Stress Management - Intro Screen - Paid - View',
  PaidIntroScreenStart = 'Stress Management - Intro Screen - Paid - Start',
  PaidIntroScreenClose = 'Stress Management - Intro Screen - Paid - Close',
  MntIntroScreenView = 'Stress Management - Intro Screen - Mnt - View',
  MntIntroScreenStart = 'Stress Management - Intro Screen - Mnt - Start',
  MntIntroScreenClose = 'Stress Management - Intro Screen - Mnt - Close'
}

export enum Referrals {
  BannerClicked = 'Referrals - Banner - Clicked',
  InvitationSent = 'Referrals - Invitation - Sent'
}

export enum LabPanels {
  UpsellViewed = 'LabPanels - Upsell - Viewed',
  UpsellSkipped = 'LabPanels - Upsell - Skipped',
  UpsellSelected = 'LabPanels - Upsell - Selected'
}

export enum Microbiome {
  UpsellViewed = 'Microbiome - Upsell - Viewed',
  UpsellSkipped = 'Microbiome - Upsell - Skipped',
  UpsellAdded = 'Microbiome - Upsell - Added'
}

export enum OnboardingUpsell {
  OfferViewed = 'Unified Onboarding - Upsell Offer Viewed',
  OfferCompleted = 'Unified Onboarding - Upsell Offer Completed',
  OfferSkipped = 'Unified Onboarding - Upsell Offer Skipped'
}

export enum UnifiedOnboarding {
  CoachingTeamSelected = 'Unified Onboarding - Coaching Team Selected',
  CoachSelected = 'Unified Onboarding - Coach Selected'
}

export enum ExperimentEvent {
  Viewed = 'Experiment Viewed'
}
